import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useOrganizationServices } from "@api/organizationService.api";

interface Props {
    filters: FiltersTypes;
}

export const OrgServiceFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: services = [] } = useOrganizationServices();
    const { orgServiceIds, orgServiceNoTier } = filters;

    const selected = useMemo(
        () => services.filter((s) => orgServiceIds?.includes(s.id)),
        [services, orgServiceIds],
    );

    const hasServiceIds = !!orgServiceIds && orgServiceIds.length > 0;

    if (!hasServiceIds) {
        return orgServiceNoTier ? <span>No tier</span> : null;
    }

    if (selected.length === 1 && !orgServiceNoTier) {
        return <span>{selected[0].name}</span>;
    }

    const tierCount = orgServiceIds.length + (orgServiceNoTier ? 1 : 0);
    return <span>{tierCount} tiers</span>;
};
